import React from "react";
import { array } from "prop-types";
import { HighlightCard } from "../HighlightCard";
import "./highlight-card-section.m.css";

export const HighlightCardSection = ({ cards = [] }) => {
  return (
    <div styleName="highlight-card-section">
      {cards.map((card, index) => (
        <HighlightCard
          key={index}
          imageUrl={card?.imageUrl}
          storyElements={card?.storyElements}
          galleryImages={card?.galleryImages}
          showCounter={card?.showCounter}
        />
      ))}
    </div>
  );
};

HighlightCardSection.propTypes = {
  cards: array,
};


